<template>
  <myhead @next="next">{{ $route.query.title || $route.meta.title}}</myhead>
  <div class="BGwhite pad12 size14 b500">
    因您申请{{$route.path.includes('cancel')? '取消订单':'退货'}}，卖家正评估损失中。
  </div>
  <div class="BGwhite pad12"><hr class="opacity4"></div>
  <div class="ml12 mr12 line20">
    <div class="size14 flex between mb20">
      <div class="b500">
        取消原因
      </div>
      <div class="C999">
        {{ info.return_reason }}
      </div>
    </div>
    <div class="size14 flex start between mb20">
      <div class="b500">
        原因补充
      </div>
      <div class="C999 width60" style="text-align:right">
        {{ info.reason }}
      </div>
    </div>
    <div class="size14 flex between mb20">
      <div class="b500">
        退还金额
      </div>
      <div class="C999">
        ￥{{ info.refund_money }}
      </div>
    </div>
    <div class="size14 flex between mb20">
      <div class="b500">
        申请时间
      </div>
      <div class="C999">
        {{ info.add_time }}
      </div>
    </div>
  </div>
</template>

<script>
import ajax from "@/utils/request.js";
export default {
  data(){
    return {
      checked:'1',
      info: {}
    }
  },
  watch:{
  },
  methods:{
    getDetail(){
    },
    apply(){
    },
    next(){
      history.back()
    }
  },
  created(){
    ajax.post("order/cancelinfo",{id: this.$route.query.id}).then(res => {
      console.log(res)
      this.info = res.data
    })
  }
}
</script>

<style>
</style>
